'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminFraudContent from './components/AdminFraudContent';

export default function AdminFraudPage() {
  return (
    <AppLayout activePath="/admin/fraud">
      <AdminFraudContent />
    </AppLayout>
  );
}
